import { render, staticRenderFns } from "./TechnicalKits.vue?vue&type=template&id=995f5af4&"
import script from "./TechnicalKits.vue?vue&type=script&lang=js&"
export * from "./TechnicalKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports